import { Directive } from "@app/components/directive";
import * as angular from "angular";
import { Dirs } from "@app/helpers/dirs";
import { IListController, IListScope } from "@app/components/kb-list/kb-list.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

export interface IListItemScope extends ng.IScope {
    item: any; // the data item that represents the node
    selectable: boolean; // controls whether the item is selectable
    image: string; // the relative path to an image in the media folder
    icon: string; // the name of a kbicon
    onDelete: (item: any) => void; // gets called when the delete button or key is pressed
    onDoubleClick: () => void;
    deletable: boolean; // will add a delete button that when pressed will call onDelete()
    childTemplate: string;

    // internal 
    _itemClick: ($event: ng.IAngularEvent) => void;
    _itemDoubleClick: ($event: ng.IAngularEvent) => void;
    _listScope: IListScope;
}

@NgComponent({
    token: Token.KbListItem,
    dependencies: [
        Token.$Timeout,
    ]
})
export class KbListItem extends Directive {
    constructor($timeout: ng.ITimeoutService) {
        super();

        this.require = "^kbList";
        this.replace = true;
        this.template = Dirs.component("kb-list-item");
        this.restrict = "AE";
        this.scope = {
            selectable: "=?",
            item: "=?",
            image: "@",
            icon: "@",
            onDelete: "&",
            onDoubleClick: "&",
            deletable: "=?",
            childTemplate: "@"
        };
        this.transclude = true;

        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            "$transclude",
            "$templateCache",
            Token.$Compile.key,
            Token.$Http.key,
            function(
                $scope: IListItemScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes,
                $transclude: ng.ITranscludeFunction,
                $templateCache: ng.ITemplateCacheService,
                $compile: ng.ICompileService,
                $http: ng.IHttpService) {
                this.scope = $scope;

                let processTemplateElement = $template => {
                    // compile the template
                    let compiled = $compile($template, $transclude);
                    // append it to the label
                    $element.html("").append($template);
                    // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                    compiled($scope.$parent);
                };

                // if a child template was provided, then use that instead of the transclusion content
                let templateName = $scope.childTemplate;
                let $template = angular.element($templateCache.get(templateName));
                if (!$template.length) {
                    $http.get(templateName).then(response => {
                        $templateCache.put(templateName, response.data);
                        $template = <JQuery<HTMLElement>>angular.element(response.data);
                        processTemplateElement($template);
                    });
                } else {
                    processTemplateElement($template);
                }
            }];
            
        this.compile = (element, atts: any) => {
            if (angular.isUndefined(atts.selectable)) {
                atts.selectable = "true";
            }
            if (angular.isUndefined(atts.deletable)) {
                atts.deletable = "true";
            }
            return this.link;
        };

        this.link = (scope: IListItemScope, element: ng.IAugmentedJQuery, atts, listController: IListController) => {
            // get parent scopes to use for selection and expansion
            let listScope = listController.scope;
            scope._listScope = listScope;
            // register the item with the parent kbList
            listController.registerListItem(scope);
              
            scope._itemClick = e => {
                // select the item if it's selectable
                if (listScope.selectable && scope.selectable) {
                    // set the selected item on the tree so it can be bound to by controllers
                    // if (listScope.multiple && e.)
                    let mouseEvent = e as any;
                    if (listScope.multiple) {
                        if (mouseEvent.ctrlKey) {
                            listScope.addToSelectedItems(scope.item);
                        } else if (mouseEvent.shiftKey) {
                            listScope.shiftToSelectedItems(scope.item);
                        } else {
                            listScope.setSelectedItems(scope.item);
                        }
                    } else {
                        listScope.selectedItem = scope.item;
                    }
                }
            };

            scope._itemDoubleClick = e => {
                scope.onDoubleClick();
            };
        };
    }
}
